import apiClient from './apiClient';

export type PDFType = 'consultation' | 'vaccination_certificate' | 'recommendations' | 'prescription';

class PDFService {
  /**
   * Generează PDF pentru vizită (fișă consultație, certificat vaccin, etc.)
   */
  async generateVisitPDF(visitId: string, type: PDFType): Promise<Blob> {
    try {
      const response = await apiClient.get(`/visits/${visitId}/pdf/${type}`, {
        responseType: 'blob'
      });

      return response.data;
    } catch (error) {
      console.error('Error generating visit PDF:', error);
      throw error;
    }
  }

  /**
   * Descarcă PDF cu nume automat
   */
  async downloadVisitPDF(visitId: string, type: PDFType, patientName?: string): Promise<void> {
    try {
      const blob = await this.generateVisitPDF(visitId, type);
      
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      
      const timestamp = new Date().toISOString().split('T')[0];
      const filename = `${type}_${patientName || visitId}_${timestamp}.pdf`;
      a.download = filename;
      
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading visit PDF:', error);
      throw error;
    }
  }

  /**
   * Print PDF direct în browser
   */
  async printVisitPDF(visitId: string, type: PDFType): Promise<void> {
    try {
      const blob = await this.generateVisitPDF(visitId, type);
      const url = URL.createObjectURL(blob);
      
      const printWindow = window.open(url, '_blank');
      if (printWindow) {
        printWindow.addEventListener('load', () => {
          printWindow.print();
        });
      }
    } catch (error) {
      console.error('Error printing visit PDF:', error);
      throw error;
    }
  }

  /**
   * Generează mai multe PDFuri simultan (batch)
   */
  async generateBatchPDFs(visitId: string, types: PDFType[]): Promise<Blob[]> {
    try {
      const promises = types.map(type => this.generateVisitPDF(visitId, type));
      return await Promise.all(promises);
    } catch (error) {
      console.error('Error generating batch PDFs:', error);
      throw error;
    }
  }
}

export const pdfService = new PDFService();

